export default function EndGameBtn({ onClick }) {
  return (
    <div className="end_game" onClick={onClick}>
        <button>Terminer</button>
    </div>
  );
}